export const REQUEST_COMPANY_VIEW = "request_company_view"
export const COMPANY_VIEW_SUCCESS = "company_view_success"
export const COMPANY_VIEW_FAILURE = "company_view_failure"

export const CLEAR_COMPANY_VIEW_STATE = "clear_company_view_state"